export default "__VITE_ASSET__57bb927f__"